module.exports = __webpack_public_path__ + "img/6e39ee2.png";